export default function ResumeSection({ title, index, children, action }) {
  return (
    <section className="mb-10">
      <div className="flex items-center justify-between mb-3 border-b border-[var(--border-default)] pb-2">
        <div className="flex items-center gap-3">
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--text-secondary)]">
            {String(index).padStart(2, "0")}
          </span>
          <h3 className="font-heading text-sm font-bold tracking-[0.2em] uppercase">
            {title}
          </h3>
        </div>
        {action}
      </div>
      {children}
    </section>
  );
}
